import React from 'react';
import { Alert, Checkbox, Tag, Typography } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import type { MutationPolicyPreview } from './types';
import { SUBSYSTEM_LABELS } from './types';

const { Text } = Typography;

type Props = {
  preview: MutationPolicyPreview;
  confirmationProvided: boolean;
  onConfirmationChange: (v: boolean) => void;
};

export function MutationImpactPreviewPanel({
  preview,
  confirmationProvided,
  onConfirmationChange
}: Props) {
  const subsystems = preview.affectedSubsystems;

  return (
    <div className="mutation-workspace__impact">
      <Alert
        type={
          preview.status === 'forbidden'
            ? 'error'
            : preview.status === 'confirmation_required'
              ? 'warning'
              : 'success'
        }
        message={preview.title}
        description={preview.message}
        showIcon
      />

      {subsystems.length > 0 && (
        <div className="mutation-workspace__impact-recalc">
          <Text strong>Будет пересчитано:</Text>
          <ul className="mutation-workspace__subsystem-list">
            {subsystems.map((s) => (
              <li key={s}>
                <CheckOutlined /> {SUBSYSTEM_LABELS[s] ?? s}
              </li>
            ))}
          </ul>
        </div>
      )}

      {(preview.requiresConfirmation || preview.status === 'confirmation_required') && (
        <div className="mutation-workspace__confirmation">
          <Tag color="orange">Требуется подтверждение</Tag>
          <Checkbox
            checked={confirmationProvided}
            onChange={(e) => onConfirmationChange(e.target.checked)}
          >
            Подтверждаю изменение маршрута
          </Checkbox>
        </div>
      )}
    </div>
  );
}
